import { IconButton, Tooltip } from "@mui/material";

const TONE_STYLES = {
  primary: {
    color: "var(--color-primary)",
    "&:hover": { backgroundColor: "var(--tab-active-bg)" },
  },
  danger: {
    color: "var(--color-danger)",
    "&:hover": { backgroundColor: "var(--danger-soft)" },
  },
  neutral: {
    color: "var(--text-secondary)",
    "&:hover": { backgroundColor: "var(--dropdown-hover)" },
  },
};

export default function TableActionButton({ label, tone = "primary", children, ...props }) {
  return (
    <Tooltip title={label} arrow enterDelay={350}>
      <IconButton
        aria-label={label}
        size="small"
        sx={TONE_STYLES[tone] || TONE_STYLES.primary}
        {...props}
      >
        {children}
      </IconButton>
    </Tooltip>
  );
}
